import img1 from "../../assets/Images/Accounting/Opening Balances.png"
import img2 from "../../assets/Images/Accounting/Add Opening Balances.png"

export default function OpeningBalances() {
  return (
    <section id="opening-balances" className="space-y-16">

      {/* HEADER / OVERVIEW (STANDARD PATTERN) */}
      <section className="bg-white rounded-xl border border-slate-200 p-10">
        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          1. Opening Balances
        </h1>

        <p className="text-md text-slate-600 max-w-3xl">
          Opening Balances define the initial financial position of the
          organization at the start of the accounting period.
        </p>

        {/* OVERVIEW */}
        <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
          <h2 className="text-lg font-semibold mb-3">
            Overview
          </h2>
          <p className="text-slate-600 text-sm">
            The Opening Balances module allows administrators to enter initial
            debit and credit amounts for accounts before regular transactions
            begin. These balances form the foundation for ledgers, trial balance,
            profit & loss, and balance sheet reports.
          </p>
        </section>
      </section>

      {/* OPENING BALANCE LIST */}
      <section className="">
        <div>
          <h3 className="font-semibold mb-2">
            Opening Balance List
          </h3>

          <p className="text-slate-600 mb-4">
            When the Opening Balances module is opened, a table displays all
            configured opening balance entries.
          </p>

          <ul className="list-disc pl-5 text-slate-600 space-y-1">
            <li>Account name (e.g. Cash, Capital)</li>
            <li>Balance type (Opening Balance / Owner’s Capital)</li>
            <li>Date of balance entry</li>
            <li>Debit amount</li>
            <li>Credit amount</li>
            <li>Actions (Edit, Delete)</li>
          </ul>
        </div>

        <div className="rounded-lg p-4 mt-4">
          <img src={img1} alt="" />
        </div>
      </section>

      {/* ADD OPENING BALANCE */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Adding an Opening Balance
        </h3>

        <p className="text-slate-600 mb-4">
          Clicking the <strong>Add Opening Balance</strong> button opens a form
          where initial account balances can be entered.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>
            <strong>Account:</strong> Select from Chart of Accounts
          </li>
          <li>
            <strong>Date:</strong> Opening balance effective date
          </li>
          <li>
            <strong>Debit:</strong> Debit amount (if applicable)
          </li>
          <li>
            <strong>Credit:</strong> Credit amount (if applicable)
          </li>
          <li>
            <strong>Type:</strong> Opening Balance or Owner’s Capital
          </li>
        </ul>

        <p className="text-slate-600 mt-3">
          Click <strong>Save</strong> to record the opening balance or
          <strong> Cancel</strong> to discard changes.
        </p>

        <div className="rounded-lg p-4  mt-4">
          <img src={img2} alt="" />
        </div>
      </section>

      {/* EDIT & DELETE */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Managing Opening Balances
        </h3>

        <p className="text-slate-600 mb-4">
          Each opening balance entry can be managed using the available actions.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>
            <strong>Edit:</strong> Modify account, date, or debit/credit values
          </li>
          <li>
            <strong>Delete:</strong> Remove an incorrect opening balance entry
          </li>
        </ul>
      </section>

      {/* ACCOUNTING IMPACT */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Accounting Impact
        </h3>

        <p className="text-slate-600 max-w-3xl">
          Opening balances directly affect all accounting reports including
          account ledgers, trial balance, profit & loss, and balance sheet.
          Incorrect entries may result in financial mismatches across the system.
        </p>
      </section>

    </section>
  );
}
